import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TAccountRegion, TBudget } from '@shared/interfaces/TProject';

@Component({
  selector: 'app-account-region-item',
  templateUrl: './account-region-item.component.html',
  styleUrls: ['./account-region-item.component.scss'],
})
export class AccountRegionItemComponent {
  @Input() public showDeleteRegion = true;
  @Input() public showBudgets = false;
  @Input() public regionData: TAccountRegion = {
    id: '',
    name: '',
    description: '',
    budgets: [],
  };
  // @Input() public handleDeleteRegion?: (region: TAccountRegion) => void = undefined;
  @Output() onDeleteRegion = new EventEmitter<TAccountRegion>();

  // holds new-budget form data
  public newBudgetData: TBudget = {
    year: new Date().getFullYear(),
    plannedBudget: 0,
    actualYearEndBudget: 0,
  };

  public deleteRegion(): void {
    this.onDeleteRegion.emit(this.regionData);
  }

  public isBudgetValid(): boolean {
    const { year, plannedBudget, actualYearEndBudget } = this.newBudgetData;
    return (
      !!year &&
      plannedBudget >= 0 &&
      actualYearEndBudget >= 0 &&
      !!this.regionData.budgets &&
      !this.regionData.budgets.some((b) => b.year === year)
    );
  }

  /** Clone newBudgetData into the array, then reset it */
  public addBudget(): void {
    if (!this.regionData.budgets) {
      this.regionData.budgets = [];
    }

    if (this.isBudgetValid()) {
      // deep‑clone in case you ever add nested objects
      const cloned: TBudget = structuredClone(this.newBudgetData);
      this.regionData.budgets.push(cloned);

      // reset form
      this.newBudgetData = {
        year: new Date().getFullYear(),
        plannedBudget: 0,
        actualYearEndBudget: 0,
      };
    }
  }

  public removeBudget(index: number): void {
    this.regionData.budgets?.splice(index, 1);
  }
}
